import { render, staticRenderFns } from "./RewardModal.vue?vue&type=template&id=073a508f&"
import script from "./RewardModal.vue?vue&type=script&lang=js&"
export * from "./RewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports